/**
 * Cowboy Caddie Theme JavaScript
 * Where Western Grit Meets Golf Precision
 */

// Mobile menu toggle
function toggleMobileMenu() {
    const nav = document.getElementById('mainNav');
    if (nav) {
        nav.classList.toggle('mobile-open');
    }
}

// DOM Content Loaded
document.addEventListener('DOMContentLoaded', function() {
    
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });

    // Add to cart functionality enhancement
    document.querySelectorAll('.add-to-cart').forEach(button => {
        button.addEventListener('click', function(e) {
            if (this.type !== 'submit') {
                e.stopPropagation();
            }
            
            const originalText = this.textContent;
            const originalColor = this.style.backgroundColor;
            
            // Don't change text if it's a form submission
            if (this.type !== 'submit') {
                this.textContent = 'Added!';
                this.style.backgroundColor = '#4a7c59';
                
                setTimeout(() => {
                    this.textContent = originalText;
                    this.style.backgroundColor = originalColor;
                }, 2000);
            }
        });
    });

    // Newsletter form enhancement
    const newsletterForm = document.getElementById('newsletterForm');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function(e) {
            const emailInput = this.querySelector('.newsletter-input');
            const email = emailInput.value;
            
            if (email) {
                // Show success message
                const button = this.querySelector('.newsletter-btn');
                const originalText = button.textContent;
                button.textContent = 'Joined!';
                
                setTimeout(() => {
                    button.textContent = originalText;
                }, 3000);
            }
        });
    }

    // Product card click handler
    document.querySelectorAll('.product-card').forEach(card => {
        card.addEventListener('click', function(e) {
            // Don't navigate if clicking the add to cart button or form
            if (!e.target.classList.contains('add-to-cart') && 
                e.target.tagName !== 'BUTTON' && 
                e.target.tagName !== 'SELECT' &&
                e.target.tagName !== 'OPTION') {
                
                const productHandle = this.getAttribute('data-product');
                if (productHandle) {
                    window.location.href = `/products/${productHandle}`;
                }
            }
        });
    });

    // Animate elements on scroll
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fade-in-up');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe elements for animation
    document.querySelectorAll('.product-card, .highlight').forEach(el => {
        observer.observe(el);
    });
    
    // Image loading enhancement
    document.querySelectorAll('.product-image img, .hero-image img, .story-image img').forEach(img => {
        img.addEventListener('load', function() {
            this.parentElement.classList.add('loaded');
            this.style.opacity = '1';
        });
        
        // If image is already loaded
        if (img.complete) {
            img.parentElement.classList.add('loaded');
            img.style.opacity = '1';
        }
    });
    
    // Smooth page transitions
    window.addEventListener('beforeunload', function() {
        document.body.style.opacity = '0.8';
    });

    // Cart count update functionality
    function updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartCount = document.getElementById('cart-count');
                if (cartCount) {
                    cartCount.textContent = cart.item_count;
                }
            })
            .catch(error => console.log('Cart update error:', error));
    }

    // Update cart count on page load
    updateCartCount();

    // Listen for cart updates
    document.addEventListener('cart:updated', updateCartCount);
    
    // Ajax cart functionality for add to cart buttons
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const formData = new FormData(this);
            const button = this.querySelector('.add-to-cart');
            const originalText = button.textContent;
            
            button.textContent = 'Adding...';
            button.disabled = true;
            
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(item => {
                button.textContent = 'Added!';
                button.style.backgroundColor = '#4a7c59';
                
                // Dispatch cart updated event
                document.dispatchEvent(new CustomEvent('cart:updated'));
                
                setTimeout(() => {
                    button.textContent = originalText;
                    button.style.backgroundColor = '';
                    button.disabled = false;
                }, 2000);
            })
            .catch(error => {
                console.error('Add to cart error:', error);
                button.textContent = 'Error';
                setTimeout(() => {
                    button.textContent = originalText;
                    button.disabled = false;
                }, 2000);
            });
        });
    });
});